import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter
} from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { useRemoteClientGet } from '@/configs/http-client';
import { usePromiseToast } from '../hooks/toast-promisse';
import { Endpoints } from '@/remote/endpoints';
import { useSearchParams } from 'react-router-dom';
import { ExerciseFormData } from '../validators/exercise-validator';

type DialogProps = {
  id: number
  isOpen: boolean
  closeDialog: () => void
}

export function DialogDetailExercise({ id, isOpen = false, closeDialog }: DialogProps) {
  const { remoteClientGet } = useRemoteClientGet();
  const { triggerToast } = usePromiseToast();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<ExerciseFormData>();
  const [params] = useSearchParams();

  const consultantFields = [
    { label: 'Nome', value: data?.nome },
    { label: 'Descrição', value: data?.descricao },
  ];

  const fetchData = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await remoteClientGet(`${Endpoints.exercise}/${id}?idUnidade=${params.get('unit')}`);
      setData(response?.data?.data);
    } catch (error) {
      setError('Erro ao carregar dados...');
      console.error(error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      triggerToast(fetchData());
    }
  }, [isOpen, id]);

  const renderField = (field: any, index: number) => (
    field.value ? (
      <p key={index} className="text-gray-400 flex gap-1">
        <strong className="text-acelerafit-gray-dark">{field.label}:</strong>
        {field.value}
      </p>
    ) : null
  );

  return (
    <Dialog open={isOpen}>
      <DialogContent className="sm:max-w-4xl">
        <DialogHeader className="border-acelerafit-gray-dark">
          <DialogTitle className="text-acelerafit-green-300">Exercício</DialogTitle>
          <DialogDescription>Detalhes</DialogDescription>
        </DialogHeader>

        {isLoading && (
          <div className="flex justify-center items-center p-4">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-acelerafit-green-300" />
          </div>
        )}

        {error && (
          <div className="text-red-500 p-4 text-center">
            {error}
          </div>
        )}

        {!isLoading && !error && (
          <div className="grid grid-cols-2 col-span-1 gap-4">
            {consultantFields.map((field, index) => renderField(field, index))}
          </div>
        )}

        <DialogFooter className="sm:justify-end">
          <Button
            onClick={() => closeDialog()}
            className="bg-acelerafit-green-300 shadow-2xl hover:bg-acelerafit-green-300 hover:opacity-85 transition-all"
          >
            Fechar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}